import React from "react";
import {RequestResult} from "../../common/api/requestResult";

interface AuthContextType {
    user: any;
    externalUserLogin: (userInfo: any) => RequestResult;
    signout: (callback: VoidFunction) => void;
}

export let AuthContext = React.createContext<AuthContextType>(null!);

export function useAuth() {
    return React.useContext(AuthContext);
}

export function useIsAdmin() :boolean{
    let context=React.useContext(AuthContext);
    return context && context.user && context.user.role==='admin';
}

export function useIsManager() :boolean{
    let context=React.useContext(AuthContext);
    return context && context.user && context.user.role==='manager';
}

export function useRole():string {
    let context=React.useContext(AuthContext);
    if(!context||!context.user)
        return '';
    return context.user.role
}
